export default 'btn-type-b'